import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './../node_modules/bulma/css/bulma.css';

import Default from "./layouts/Default.vue";
import Public from "./layouts/Public.vue";


Vue.component('default-layout', Default);
Vue.component('public-layout', Public);


// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json";

// Import the plugin here
import { Auth0Plugin } from "./auth";


// Global functions
Vue.mixin({
  methods: {
    showApplicationStatus: function (endorsed, awarded) {
      var application_status = "New"
      if(awarded == 1)
      {
        application_status = "Awarded"
      }
      else if(awarded == 2)
      {
        application_status = "Not Awarded"
      }
      else if(endorsed == 1)
      {
        application_status = "Endorsed"
      }
      else if(endorsed == 2)
      {
        application_status = "Not Endorsed"
      }
      
      return application_status
    },
    async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
  },
})

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')